module.exports = __webpack_public_path__ + "web_static/img/right_white.2c8d953f.png";